/* eslint-disable n/no-process-env */
import z from 'zod'

const envSchema = z.object({
  NODE_ENV: z.enum(['development', 'production', 'test']).catch('development'),
  API_HOST: z.string(),
  AUTH0_DOMAIN: z.string(),
  AUTH0_SPA_APP_CLIENT_ID: z.string(),
  BUGSNAG_API_KEY: z.string().optional(),
  POSTHOG_API_KEY: z.string().optional(),
  POSTHOG_API_URL: z.string().optional(),
  LOGTAIL_SOURCE_TOKEN: z.string().optional(),
})

//
// NOTE: 本番での環境変数は、.env.productionで定義している
// （秘匿性の高い値を含むバックエンドの環境変数はterraform/KMSで定義しているが、SPAアプリにおける環境変数はどうせユーザーに露出するので、秘匿性が低く、リポジトリ内部で管理する利便性をとる判断）
//
export const envVariables = envSchema.parse({
  NODE_ENV: process.env.NODE_ENV,
  API_HOST: process.env.NEXT_PUBLIC_API_HOST,
  AUTH0_DOMAIN: process.env.NEXT_PUBLIC_AUTH0_DOMAIN,
  AUTH0_SPA_APP_CLIENT_ID: process.env.NEXT_PUBLIC_AUTH0_SPA_APP_CLIENT_ID,
  BUGSNAG_API_KEY: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
  POSTHOG_API_KEY: process.env.NEXT_PUBLIC_POSTHOG_API_KEY,
  POSTHOG_API_URL: process.env.NEXT_PUBLIC_POSTHOG_API_URL,
  LOGTAIL_SOURCE_TOKEN: process.env.NEXT_PUBLIC_LOGTAIL_SOURCE_TOKEN,
})
